// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"3946": "4bc5c6e7","7997": "7eb5e739",}[chunkId] + ".css"
}